export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'What is KittyPot?',
    answer:
      'KittyPot helps groups track shared expenses, split costs fairly and keep track of who owes what — for trips, nights out, house shares and events.',
  },
  {
    question: 'What is a kitty?',
    answer:
      'A kitty is one shared space for a group. It holds the members, everything they spend, and the record of who has settled up.',
  },
  {
    question: 'Is KittyPot free?',
    answer:
      'Yes. Every feature, every kitty and every member is free, with no subscription.',
  },
  {
    question: 'Does KittyPot hold my money?',
    answer:
      "You're always in control of your money — you settle up directly with each other, your own way. KittyPot keeps the record, not the funds.",
  },
  {
    question: 'How do I invite people?',
    answer:
      'Share a link, a code or a QR to scan, or invite people straight from your contacts. Admins can approve join requests as people arrive.',
  },
  {
    question: 'Does everyone need the app?',
    answer:
      'No. Anyone you invite can open the link and take part from their browser. The app gives you the full experience, including My Balance across all your kitties.',
  },
  {
    question: 'What if someone is not on KittyPot yet?',
    answer:
      'Add them by name so their share is tracked from the start. They can claim that name later when they join.',
  },
  {
    question: 'How do expenses work?',
    answer:
      'Add what was spent, choose who paid, and pick who the expense is shared with. Split it equally or set a custom amount for each person.',
  },
  {
    question: 'How do settlements work?',
    answer:
      'KittyPot shows clearly who needs to pay whom. You pay each other by bank transfer or cash, mark it as paid, and the person receiving it confirms when it lands.',
  },
  {
    question: 'Can I use different currencies?',
    answer:
      'Yes. You can record spends in more than one currency. Converted amounts are shown for convenience and may differ from the rate your bank uses when you settle.',
  },
  {
    question: 'How do receipts work?',
    answer:
      'You can attach a receipt image to an expense so the group has a record of what was bought. Always check the details on an expense before saving it.',
  },
  {
    question: 'What is My Balance?',
    answer:
      'My Balance brings together what you owe and what you are owed across every kitty, with per-person and per-kitty amounts.',
  },
  {
    question: 'Can I delete my account?',
    answer:
      'Yes. Go to Settings → Delete account in the app, or email us from the address on your account. We remove or anonymise your account information where appropriate; limited shared records may need to remain so other members’ balances stay accurate.',
  },
  {
    question: 'How is my data protected?',
    answer:
      'Only members of a kitty can see its expenses in the app. We use encrypted connections and access controls, we do not sell your data, and this website runs no analytics or advertising trackers. Our Privacy Policy explains what we process and why.',
  },
]
